import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ScenariosPageRoutingModule } from "./scenarios-routing.module";
import { ScenariosPage } from "./scenarios.page";
import { LogoModule } from "src/app/components/logo/logo.module";
import { FilterScenariosModule } from "./pipes/filter-scenarios/filter-scenarios.module";
import { PopoverModule } from "src/app/components/popover/popover.module";
import { ScenarioPageModule } from "src/app/modals/scenario/scenario.module";
import { ToTriggerModule } from "src/app/pipes/to-trigger/to-trigger.module";
import { TranslateModule } from "@ngx-translate/core";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    IonicModule,
    ScenariosPageRoutingModule,
    LogoModule,
    FilterScenariosModule,
    PopoverModule,
    ScenarioPageModule,
    ToTriggerModule,
    TranslateModule,
  ],
  declarations: [ScenariosPage],
})
export class ScenariosPageModule {}
